var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsWindow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 109,
    viewBox: "0 0 220 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.555786 103.264V49.96C0.555786 46.2748 4.40675 43.8559 7.72651 45.4558L64.8926 73.0059C68.7193 74.8501 68.6486 80.3241 64.7756 82.0689L7.60951 107.822C4.3006 109.313 0.555786 106.893 0.555786 103.264Z",
    fill: "#FFF4D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555786 47C0.555786 21.0426 21.5984 0 47.5558 0H172.556C198.513 0 219.556 21.0426 219.556 47C219.556 72.9574 198.513 94 172.556 94H47.5558C21.5984 94 0.555786 72.9574 0.555786 47Z",
    fill: "#FFF4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsWindow);
export default __webpack_public_path__ + "static/media/chatsWindow.9f91d612d3853dc7cca7cdd510f83793.svg";
export { ForwardRef as ReactComponent };